export function toDate(value: string | Date): Date {
	if (typeof value !== 'string') return value;
	const dateOnlyMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
	if (dateOnlyMatch) {
		// new Date('yyyy-MM-dd') parses as UTC midnight, which shows the previous day for every user
		// west of GMT (all of Argentina). A date-only string must be read as local midnight.
		return new Date(
			Number(dateOnlyMatch[1]),
			Number(dateOnlyMatch[2]) - 1,
			Number(dateOnlyMatch[3])
		);
	}
	return new Date(value);
}

function pad2(n: number): string {
	return n < 10 ? `0${n}` : String(n);
}

export function formatDate(date: string | Date | null | undefined): string {
	if (!date) return '';
	const d = toDate(date);
	if (isNaN(d.getTime())) return '';
	return `${pad2(d.getDate())}-${pad2(d.getMonth() + 1)}-${d.getFullYear()}`;
}

export function formatTime(date: string | Date | null | undefined): string {
	if (!date) return '';
	const d = toDate(date);
	if (isNaN(d.getTime())) return '';
	return `${pad2(d.getHours())}:${pad2(d.getMinutes())}:${pad2(d.getSeconds())}`;
}

export function formatDateTime(date: string | Date | null | undefined): string {
	if (!date) return '';
	const d = toDate(date);
	if (isNaN(d.getTime())) return '';
	return `${formatDate(d)} ${formatTime(d)}`;
}

export type DateInputFormat = {
	parts: ('day' | 'month' | 'year')[];
	separator: string;
	placeholder: string;
};

export const DATE_INPUT_FORMAT: DateInputFormat = {
	parts: ['day', 'month', 'year'],
	separator: '-',
	placeholder: 'dd-mm-aaaa'
};

export function getUserLocale(): string {
	if (typeof navigator !== 'undefined' && navigator.language) {
		return navigator.language;
	}
	return 'en-US';
}

export function toLocalDateString(date: Date): string {
	return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
}

export function todayLocal(): string {
	return toLocalDateString(new Date());
}

export function toUtcIsoSeconds(date: Date): string {
	return date.toISOString().replace(/\.\d{3}Z$/, 'Z');
}

export function nowUtcIsoSeconds(): string {
	return toUtcIsoSeconds(new Date());
}
